import React from 'react'
import { compose } from 'recompose'
import classnames from 'classnames'
import { Input, Icon } from 'semantic-ui-react'

const TextSearch = (props) => {
  const { label,hideLabel=false, dummy, placeHolder, input, require, editable, filterKey, style, meta: { touched, error } } = props
  const activeClass = classnames({error: (touched && error)})

  if (filterKey && input.value && input.value === filterKey) {
    input.value = '-'
  }

  const enterPass = (e) => {
    if(e.key === 'Enter') {
      props.onEnterPass(e.target.value)      
    }
  }

  return (
    <div className='fieldRow' style={{...style}}>
      {!hideLabel&&<div className='fieldLabel'>
        <span>{label}</span>
        {require ? <div className='require'>*</div> : null}
        {touched && error ? <div className='error'>{error}</div> : null}
        <div style={{flex:1}}/>
        {props.showPODetail()}
      </div>}
      <div className={`fieldInput ${editable!==false?'editableTextInput':''}`} style={dummy?{visibility:'hidden',maxHeight:0}:{}}>
        <Input
          {...input}
          fluid
          disabled={editable === false}
          className={activeClass}
          placeholder={placeHolder}
          onKeyDown={(e)=>enterPass(e)}
          icon={props.showSearch&&<Icon name='search' inverted circular link onClick={()=>props.onSearchClick&&props.onSearchClick(input.value)}/>}
        />
      </div>
    </div>
  )
}

export default compose()(TextSearch)